import styled from 'styled-components'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import AccordionSummary from '@material-ui/core/AccordionSummary'

export const Title = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #6d6e71;
  
  @media(max-width: 767px) {
    color: #414042;
  }
`
export const ContentContainer = styled.div`
    -webkit-overflow-scrolling: touch;    
    width: 100%; 
    padding-bottom: 10px;
    overflow-y: auto;
    max-height: 210px;

    @media(min-width: 768px) {
      padding-bottom: 22px;
    }

    :after {
      display: ${props => (props.showAfter ? 'block' : 'none')};
      content:"";
      position:absolute;
      bottom:0;
      left:0;
      height:45px;
      width:100%;
      background: -moz-linear-gradient(top,  rgba(255,255,255,0) 0%, rgba(255,255,255,0.83) 35%, rgba(255,255,255,1) 100%); /* FF3.6-15 */
      background: -webkit-linear-gradient(top,  rgba(255,255,255,0) 0%,rgba(255,255,255,0.83) 35%,rgba(255,255,255,1) 100%); /* Chrome10-25,Safari5.1-6 */
      background: linear-gradient(to bottom,  rgba(255,255,255,0) 0%,rgba(255,255,255,0.83) 35%,rgba(255,255,255,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#00ffffff', endColorstr='#ffffff',GradientType=0 ); /* IE6-9 */
      border-radius: 12px;
    }
  `

export const CustomDetails = styled(AccordionDetails)`
  @media(max-width: 768px){
      padding: 0!important;
  }
`

export const CustomSummary = styled(AccordionSummary)`
  @media(max-width: 768px){
    margin: 0px;
    padding: 0!important;
    .MuiAccordionSummary-content.Mui-expanded {
      margin: 0 !important;
    }
    &.MuiAccordionSummary-root.Mui-expanded {
      min-height: 0 !important;
    }
  }
`
